module.exports = __webpack_public_path__ + "static/img/__8955.b8cd99f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8955.jpg
// module id = 2PX6
// module chunks = 0